import { render, staticRenderFns } from "./sh_AdminChat.vue?vue&type=template&id=c7e2ba62&scoped=true&"
import script from "./sh_AdminChat.vue?vue&type=script&lang=js&"
export * from "./sh_AdminChat.vue?vue&type=script&lang=js&"
import style0 from "./sh_AdminChat.vue?vue&type=style&index=0&id=c7e2ba62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e2ba62",
  null
  
)

export default component.exports